import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const SettingsLogisticsWarehouseLazy = loadable(
    () => import(/* webpackChunkName: "SettingsLogisticsWarehouse" */ './LogisticsWarehouseSuspense')
);

export const SettingsLogisticsWarehouseAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <SettingsLogisticsWarehouseLazy />
    </DelayedSuspense>
);
